<header *ngIf="!isInIframe" #header></header>
<main id="main" role="main" itemprop="mainContentOfPage" sbbFlyingFocus>
  <router-outlet></router-outlet>
</main>
<footer *ngIf="!isInIframe" #footer></footer>
